// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  padding: 0 10px;
  --background: white !important;
}

.promo-info {
  align-items: center;
  padding: 10px 17px;
  background: white;
  margin: 10px 10px 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  font-size: 14px;
  display: none;
}
.promo-info .name {
  width: 180px;
}

.min-order {
  margin: 10px 10px 0;
}

.card-actions {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.footer-button.invalid {
  --background: darkgrey;
  color: grey;
}

.wrapper {
  max-height: 100%;
  flex-direction: column;
  display: flex;
  height: 100%;
}

.article {
  text-align: center;
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 992px) {
  .article {
    height: 35px;
  }
}

.ordered-articles-container {
  flex: 1;
  overflow-y: scroll;
}
.ordered-articles-container:not(:has(.order-item)) {
  display: flex;
  align-items: center;
  justify-content: center;
}

.promo-error {
  margin: 10px;
  font-size: 13px;
  text-align: center;
  color: red;
  display: none;
}

.add-to-order-button {
  margin: 4px 12px 12px 12px;
}

app-payment-methods-display {
  margin: 0 12px;
  display: block;
}

.from-menu .title {
  color: var(--ion-color-dark);
}

.footer-btn {
  position: sticky;
  bottom: 20px;
  margin: 10px 15px 10px;
}
@media (max-width: 399px) {
  .footer-btn {
    bottom: 13px;
    min-height: 55px;
    height: 55px;
  }
}
.footer-btn .footer-btn-text {
  color: var(--ion-color-primary-contrast);
  font-size: var(--order-page-footer-btn-text-font-size);
  line-height: var(--order-page-footer-btn-text-line-height);
  font-family: Tusker, sans-serif;
}

.hinter-text {
  display: flex;
  justify-content: center;
  padding: 20px 35px;
}
.hinter-text p {
  font-size: 10px;
  text-align: center;
  color: var(--ion-color-subtitle);
  line-height: 15px;
}

.block-sanifair {
  display: flex;
  align-items: center;
}
.block-sanifair ion-img {
  margin-right: 10px;
  width: 20px;
  height: 20px;
}
.block-sanifair h2 {
  color: var(--ion-color-primary);
  font-size: 14px;
  font-family: AppFontBold, sans-serif;
  text-transform: uppercase;
}

.footer_text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px 0px;
}

.title_block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 25px;
}
@media (max-width: 399px) {
  .title_block {
    padding: 10px 25px;
  }
}
@media (min-width: 991px) {
  .title_block {
    justify-content: center;
  }
}
.title_block .title {
  color: var(--ion-color-secondary);
  margin: 0;
  font-size: 26px;
  text-align: left;
  line-height: 26px;
  font-family: Tusker, san-serif;
}
@media (max-width: 399px) {
  .title_block .title {
    font-size: 22px;
  }
}
@media (min-width: 991px) {
  .title_block .title {
    text-align: center;
    text-transform: uppercase;
    color: white;
  }
}
@media (max-width: 450px) {
  .title_block .title {
    font-size: 20px;
    line-height: 24px;
  }
}
.title_block .add-more {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
@media (min-width: 991px) {
  .title_block .add-more {
    display: none;
  }
}
.title_block .add-more .add-text {
  color: white;
  font-size: 12px;
  line-height: var(--order-page-add-text-line-height);
  padding: 7px 5px;
  font-family: Tusker, sans-serif;
  text-transform: uppercase;
  background: url('purple.png') no-repeat center center/100% 100%;
}
@media (max-width: 450px) {
  .title_block .add-more .add-text {
    font-size: 10px;
  }
}
.title_block .add-more p {
  margin: 0 0 0 10px;
  padding-bottom: 1%;
}

.sanifair_section {
  width: 100%;
  padding: 0 15px;
  margin-bottom: 10px;
}
@media (min-width: 991px) {
  .sanifair_section {
    padding: 0 13px;
  }
}
.sanifair_section__item {
  background: url('sanifair_background.png') no-repeat center center/100% 100%;
  width: 100%;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media (max-width: 399px) {
  .sanifair_section__item {
    padding: 7px 20px;
  }
}
.sanifair_section__item__info {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.sanifair_section__item__info ion-img {
  width: 40px;
  height: 40px;
  margin-right: 5px;
}
.sanifair_section__item__info h3 {
  font-family: Tusker, sans-serif;
  color: var(--ion-color-primary);
  font-size: 16px;
}
.sanifair_section__item ion-icon {
  width: 40px;
  height: 40px;
}

.recommenation_section {
  background: url('recomendation_background.png') no-repeat center center/100% 100%;
  padding: 10px;
  margin: 10px 0px;
}
@media (max-width: 992px) {
  .recommenation_section {
    padding: 10px 20px;
  }
}
@media (max-width: 400px) {
  .recommenation_section {
    padding: 10px 10px;
    margin: 6px 0px;
  }
}
.recommenation_section .recom_title {
  color: white;
  font-family: Tusker, sans-serif;
  font-size: 14px;
}
.recommenation_section .recommenation_section_articles__item {
  display: flex;
  padding: 5px 5px;
  flex-direction: column;
  position: relative;
}
@media (max-width: 399px) {
  .recommenation_section .recommenation_section_articles__item {
    zoom: 0.8;
  }
}
.recommenation_section .recommenation_section_articles__item .add-article {
  position: absolute;
  width: 30px;
  height: 30px;
  right: 20px;
  top: 20px;
  z-index: 5;
}
.recommenation_section .recommenation_section_articles__item img {
  width: 160px;
  height: 80px;
  object-fit: contain;
}
.recommenation_section .recommenation_section_articles__item div {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.recommenation_section .recommenation_section_articles__item div .left-section {
  width: 60%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.recommenation_section .recommenation_section_articles__item div h3 {
  color: white;
  font-size: 11px;
  font-family: Tusker, sans-serif;
  margin-right: 5px;
}
.recommenation_section .recommenation_section_articles__item div .price_pfand_block {
  width: 40%;
}
.recommenation_section .recommenation_section_articles__item div .rec-price {
  align-self: flex-start;
}
@media (max-width: 400px) {
  .recommenation_section .recommenation_section_articles__item div .name {
    word-break: break-word !important;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
  }
}
.recommenation_section__item::after {
  content: " ";
  height: 100px;
  background: #990636;
  position: absolute;
  width: 1px;
  top: 50%;
  transform: translateY(-50%);
  right: 0px;
}

.total_price_block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 25px 10px;
}
@media (max-width: 399px) {
  .total_price_block {
    padding: 5px 25px 5px;
  }
}
.total_price_block h3 {
  font-family: Tusker, sans-serif;
  font-size: 16px;
}
@media (min-width: 991px) {
  .total_price_block h3 {
    color: white;
  }
}

.no-articles h3 {
  font-family: Tusker, sans-serif;
}
@media (min-width: 991px) {
  .no-articles h3 {
    color: white;
    font-size: 16px;
  }
}

swiper-container {
  height: 100%;
}
swiper-container swiper-slide {
  width: 50%;
  max-width: 50% !important;
}

swiper-container {
  transition-timing-function: linear;
}

.price_pfand_block {
  display: flex;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
}

.measurment_text {
  font-family: AppFont, sans-serif;
  font-size: 8px;
  color: white;
  text-align: left;
  padding-top: 5px;
}

.deposit_text {
  padding-top: 2px;
  font-size: 11px;
  font-family: Tusker, sans-serif;
  color: white;
  padding-top: 7px;
}

::ng-deep .ordered-articles-container::-webkit-scrollbar {
  -webkit-appearance: none;
}

::ng-deep .ordered-articles-containerl::-webkit-scrollbar:vertical {
  width: 11px;
  background-color: rgb(233, 245, 233);
}

::ng-deep .ordered-articles-container::-webkit-scrollbar-thumb {
  border-radius: 8px;
  border: 2px solid rgb(233, 245, 233) !important; /* should match background, can't be transparent */
  background-color: rgba(0, 0, 0, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/app/components/order-content/order-content.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,eAAA;EACA,8BAAA;AADD;;AAIA;EACC,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,eAAA;EAMA,aAAA;AAND;AAEC;EACC,YAAA;AAAF;;AAMA;EACC,mBAAA;AAHD;;AAMA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAHD;;AAMA;EACC,sBAAA;EACA,WAAA;AAHD;;AAMA;EACC,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;AAHD;;AAMA;EACC,kBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAHD;ACzCE;EDuCF;IAOE,YAAA;EADA;AACF;;AAIA;EACC,OAAA;EACA,kBAAA;AADD;AAKC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;AAHF;;AAOA;EACC,YAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;AAJD;;AAOA;EACC,0BAAA;AAJD;;AAOA;EACC,cAAA;EACA,cAAA;AAJD;;AAQC;EACC,4BAAA;AALF;;AAQA;EACC,gBAAA;EACA,YAAA;EAQA,sBAAA;AAZD;AAMC;EAJD;IAKE,YAAA;IACE,gBAAA;IACA,YAAA;EAHF;AACF;AAOC;EACC,wCAAA;EACA,sDAAA;EACA,0DAAA;EACA,+BAAA;AALF;;AAQA;EACC,aAAA;EACA,uBAAA;EACA,kBAAA;AALD;AAMC;EACC,eAAA;EACA,kBAAA;EACA,gCAAA;EACA,iBAAA;AAJF;;AAOA;EACC,aAAA;EACA,mBAAA;AAJD;AAKC;EACC,kBAAA;EACA,WAAA;EACA,YAAA;AAHF;AAKC;EACC,+BAAA;EACA,eAAA;EACA,oCAAA;EACA,yBAAA;AAHF;;AAMA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAHD;;AAKA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAFD;AAGC;EALD;IAME,kBAAA;EAAA;AACF;ACtJE;ED+IF;IASE,uBAAA;EAEA;AACF;AADC;EACC,iCAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;AAGF;AAFE;EAPD;IAQE,eAAA;EAKD;AACF;ACxKE;ED0JD;IAWE,kBAAA;IACA,yBAAA;IACA,YAAA;EAOD;AACF;AANE;EAfD;IAgBE,eAAA;IACA,iBAAA;EASD;AACF;AAPC;EAIC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAMF;AC3LE;ED8KD;IAEE,aAAA;EAeD;AACF;AATE;EACC,YAAA;EACA,eAAA;EACA,mDAAA;EACA,gBAAA;EACA,+BAAA;EACA,yBAAA;EACA,+DAAA;AAWH;AATG;EATD;IAUE,eAAA;EAYF;AACF;AAVE;EACC,kBAAA;EACA,kBAAA;AAYH;;AARA;EACC,WAAA;EAEA,eAAA;EAsCA,mBAAA;AA3BD;ACxNE;ED0MF;IAKE,eAAA;EAaA;AACF;AAVC;EACC,4EAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAYF;AAVI;EARH;IASK,iBAAA;EAaJ;AACF;AAXE;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;AAaH;AAZG;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AAcJ;AAZG;EACC,+BAAA;EACA,+BAAA;EACA,eAAA;AAcJ;AAXE;EACC,WAAA;EACA,YAAA;AAaH;;AARA;EACC,iFAAA;EACA,aAAA;EACA,gBAAA;AAWD;AC7PE;ED+OF;IAKE,kBAAA;EAaA;AACF;AAXC;EARD;IASE,kBAAA;IACA,eAAA;EAcA;AACF;AAZC;EACC,YAAA;EACA,+BAAA;EACA,eAAA;AAcF;AAPC;EACC,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AASF;AAPI;EANH;IAOK,SAAA;EAUJ;AACF;AARE;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AAUH;AARE;EACC,YAAA;EACA,YAAA;EACA,mBAAA;AAUH;AARE;EACC,aAAA;EACA,8BAAA;EACA,uBAAA;AAUH;AATG;EACC,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;AAWJ;AATG;EACC,YAAA;EACA,eAAA;EACA,+BAAA;EACA,iBAAA;AAWJ;AATG;EACC,UAAA;AAWJ;AATG;EACC,sBAAA;AAWJ;AAPI;EADD;IAEE,iCAAA;IACA,oBAAA;IACA,4BAAA;IACA,gBAAA;IACA,uBAAA;IACA,qBAAA;EAUH;AACF;AANC;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;AAQF;;AAJA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;AAOD;AANE;EALF;IAMI,qBAAA;EASF;AACF;AARC;EACC,+BAAA;EACA,eAAA;AAUF;ACvWE;ED2VD;IAIE,YAAA;EAYD;AACF;;AALC;EACC,+BAAA;AAQF;AChXE;EDuWD;IAGE,YAAA;IACA,eAAA;EAUD;AACF;;AAPA;EAGC,YAAA;AAQD;AAPC;EACC,UAAA;EACA,yBAAA;AASF;;AALA;EACC,kCAAA;AAQD;;AANA;EACC,aAAA;EACA,iCAAA;EACA,kCAAA;EACA,sCAAA;AASD;;AAPA;EACC,gCAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AAUD;;AARA;EACC,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,YAAA;EACA,gBAAA;AAWD;;AA8CA;EACI,wBAAA;AA3CJ;;AA8CA;EACI,WAAA;EACC,oCAAA;AA3CL;;AA8CA;EACI,kBAAA;EACA,+CAAA,EAAA,kDAAA;EACA,oCAAA;AA3CJ","sourcesContent":["@import '../../../theme/mixins';\n\nion-content {\n\tpadding: 0 10px;\n\t--background: white !important;\n}\n\n.promo-info {\n\talign-items: center;\n\tpadding: 10px 17px;\n\tbackground: white;\n\tmargin: 10px 10px 0;\n\tbox-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);\n\tborder-radius: 4px;\n\tfont-size: 14px;\n\n\t.name {\n\t\twidth: 180px;\n\t}\n\n\tdisplay: none;\n}\n\n.min-order {\n\tmargin: 10px 10px 0;\n}\n\n.card-actions {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n}\n\n.footer-button.invalid {\n\t--background: darkgrey;\n\tcolor: grey;\n}\n\n.wrapper {\n\tmax-height: 100%;\n\tflex-direction: column;\n\tdisplay: flex;\n\theight: 100%;\n}\n\n.article {\n\ttext-align: center;\n\theight: 110px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\t@include mobile {\n\t\theight: 35px;\n\t}\n}\n\n.ordered-articles-container {\n\tflex: 1;\n\toverflow-y: scroll;\n\t// overflow: -moz-scrollbars-vertical; \n\t// -webkit-overflow-scrolling: auto;\n\n\t&:not(:has(.order-item)) {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t}\n}\n\n.promo-error {\n\tmargin: 10px;\n\tfont-size: 13px;\n\ttext-align: center;\n\tcolor: red;\n\tdisplay: none;\n}\n\n.add-to-order-button {\n\tmargin: 4px 12px 12px 12px;\n}\n\napp-payment-methods-display {\n\tmargin: 0 12px;\n\tdisplay: block;\n}\n\n.from-menu {\n\t.title {\n\t\tcolor: var(--ion-color-dark);\n\t}\n}\n.footer-btn {\n\tposition: sticky;\n\tbottom: 20px;\n\n\t@media (max-width: 399px) {\n\t\tbottom: 13px;\n    min-height: 55px;\n    height: 55px;\n    // margin: 7px 16px;\n\t}\n\tmargin: 10px 15px 10px;\n\n\t.footer-btn-text {\n\t\tcolor: var(--ion-color-primary-contrast);\n\t\tfont-size: var(--order-page-footer-btn-text-font-size);\n\t\tline-height: var(--order-page-footer-btn-text-line-height);\n\t\tfont-family: Tusker, sans-serif;\n\t}\n}\n.hinter-text {\n\tdisplay: flex;\n\tjustify-content: center;\n\tpadding: 20px 35px;\n\tp {\n\t\tfont-size: 10px;\n\t\ttext-align: center;\n\t\tcolor: var(--ion-color-subtitle);\n\t\tline-height: 15px;\n\t}\n}\n.block-sanifair {\n\tdisplay: flex;\n\talign-items: center;\n\tion-img {\n\t\tmargin-right: 10px;\n\t\twidth: 20px;\n\t\theight: 20px;\n\t}\n\th2 {\n\t\tcolor: var(--ion-color-primary);\n\t\tfont-size: 14px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t\ttext-transform: uppercase;\n\t}\n}\n.footer_text {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 15px 0px;\n}\n.title_block {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 15px 25px;\n\t@media (max-width: 399px) {\n\t\tpadding: 10px 25px;\n\t}\n\t@include desktop {\n\t\tjustify-content: center;\n\t}\n\t.title {\n\t\tcolor: var(--ion-color-secondary);\n\t\tmargin: 0;\n\t\tfont-size: 26px;\n\t\ttext-align: left;\n\t\tline-height: 26px;\n\t\tfont-family: Tusker, san-serif;\n\t\t@media (max-width: 399px) {\n\t\t\tfont-size: 22px;\n\t\t}\n\t\t@include desktop {\n\t\t\ttext-align: center;\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: white;\n\t\t}\n\t\t@media (max-width: 450px) {\n\t\t\tfont-size: 20px;\n\t\t\tline-height: 24px;\n\t\t}\n\t}\n\t.add-more {\n\t\t@include desktop {\n\t\t\tdisplay: none;\n\t\t}\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tcursor: pointer;\n\n\t\t.add-text {\n\t\t\tcolor: white;\n\t\t\tfont-size: 12px;\n\t\t\tline-height: var(--order-page-add-text-line-height);\n\t\t\tpadding: 7px 5px;\n\t\t\tfont-family: Tusker, sans-serif;\n\t\t\ttext-transform: uppercase;\n\t\t\tbackground: url('../../../assets/tabilo/purple.png') no-repeat center center/ 100% 100%;\n\t\t\t// background-size: ;\n\t\t\t@media (max-width: 450px) {\n\t\t\t\tfont-size: 10px;\n\t\t\t}\n\t\t}\n\t\tp {\n\t\t\tmargin: 0 0 0 10px;\n\t\t\tpadding-bottom: 1%;\n\t\t}\n\t}\n}\n.sanifair_section {\n\twidth: 100%;\n\t// padding: 0 20px;\n\tpadding: 0 15px;\n\t@include desktop {\n\t\tpadding: 0 13px;\n\n\t}\n\t\n\t&__item {\n\t\tbackground: url('../../../assets/tabilo/sanifair_background.png') no-repeat center center/ 100% 100%;\n\t\twidth: 100%;\n\t\tpadding: 10px 20px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\n    @media (max-width: 399px) {\n      padding: 7px 20px;\n    }\n\n\t\t&__info {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: flex-start;\n\t\t\talign-items: center;\n\t\t\tion-img {\n\t\t\t\twidth: 40px;\n\t\t\t\theight: 40px;\n\t\t\t\tmargin-right: 5px;\n\t\t\t}\n\t\t\th3 {\n\t\t\t\tfont-family: Tusker, sans-serif;\n\t\t\t\tcolor: var(--ion-color-primary);\n\t\t\t\tfont-size: 16px;\n\t\t\t}\n\t\t}\n\t\tion-icon {\n\t\t\twidth: 40px;\n\t\t\theight: 40px;\n\t\t}\n\t}\n\tmargin-bottom: 10px;\n}\n.recommenation_section {\n\tbackground: url('../../../assets/tabilo/recomendation_background.png') no-repeat center center/ 100% 100%;\n\tpadding: 10px;\n\tmargin: 10px 0px;\n\t@include mobile {\n\t\tpadding: 10px 20px;\n\t}\n\n\t@media (max-width: 400px) {\n\t\tpadding: 10px 10px;\n\t\tmargin: 6px 0px;\n\t}\n\n\t.recom_title {\n\t\tcolor: white;\n\t\tfont-family: Tusker, sans-serif;\n\t\tfont-size: 14px;\n\t}\n\t// .recommenation_section_articles {\n\t//   width: 100%;\n\t//   overflow: auto;\n\t//   display: flex;\n\t//   align-items: top;\n\t.recommenation_section_articles__item {\n\t\tdisplay: flex;\n\t\tpadding: 5px 5px;\n\t\tflex-direction: column;\n\t\tposition: relative;\n\n    @media (max-width: 399px) {\n      zoom: 0.8;\n    }\n\n\t\t.add-article {\n\t\t\tposition: absolute;\n\t\t\twidth: 30px;\n\t\t\theight: 30px;\n\t\t\tright: 20px;\n\t\t\ttop: 20px;\n\t\t\tz-index: 5;\n\t\t}\n\t\timg {\n\t\t\twidth: 160px;\n\t\t\theight: 80px;\n\t\t\tobject-fit: contain;\n\t\t}\n\t\tdiv {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: flex-start;\n\t\t\t.left-section {\n\t\t\t\twidth: 60%;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\talign-items: flex-start;\n\t\t\t\tjustify-content: flex-start;\n\t\t\t}\n\t\t\th3 {\n\t\t\t\tcolor: white;\n\t\t\t\tfont-size: 11px;\n\t\t\t\tfont-family: Tusker, sans-serif;\n\t\t\t\tmargin-right: 5px;\n\t\t\t}\n\t\t\t.price_pfand_block {\n\t\t\t\twidth: 40%;\n\t\t\t}\n\t\t\t.rec-price {\n\t\t\t\talign-self: flex-start;\n\t\t\t}\n\n\t\t\t.name {\n\t\t\t\t@media (max-width: 400px) {\n\t\t\t\t\tword-break: break-word !important;\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t-webkit-box-orient: vertical;\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t-webkit-line-clamp: 2;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&__item::after {\n\t\tcontent: ' ';\n\t\theight: 100px;\n\t\tbackground: #990636;\n\t\tposition: absolute;\n\t\twidth: 1px;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t\tright: 0px;\n\t}\n\t// }\n}\n.total_price_block {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 15px 25px 10px;\n  @media (max-width: 399px) {\n    padding: 5px 25px 5px;\n  }\n\th3 {\n\t\tfont-family: Tusker, sans-serif;\n\t\tfont-size: 16px;\n\t\t@include desktop {\n\t\t\tcolor: white;\n\t\t}\n\t}\n\t// @include desktop {\n\t//   display: none;\n\t// }\n}\n.no-articles {\n\th3 {\n\t\tfont-family: Tusker, sans-serif;\n\t\t@include desktop {\n\t\t\tcolor: white;\n\t\t\tfont-size: 16px;\n\t\t}\n\t}\n}\nswiper-container {\n\t// width: 400px !important;\n\t// max-width: 400px !important;\n\theight: 100%;\n\tswiper-slide {\n\t\twidth: 50%;\n\t\tmax-width: 50% !important;\n\t}\n}\n\nswiper-container {\n\ttransition-timing-function: linear;\n}\n.price_pfand_block {\n\tdisplay: flex;\n\tflex-direction: column !important;\n\talign-items: flex-start !important;\n\tjustify-content: flex-start !important;\n}\n.measurment_text {\n\tfont-family: AppFont, sans-serif;\n\tfont-size: 8px;\n\tcolor: white;\n\ttext-align: left;\n\tpadding-top: 5px;\n}\n.deposit_text {\n\tpadding-top: 2px;\n\tfont-size: 11px;\n\tfont-family: Tusker, sans-serif;\n\tcolor: white;\n\tpadding-top: 7px;\n}\n\n// ::-webkit-scrollbar {\n// \twidth: 12px; /* Width of the scrollbar */\n// \theight: 12px; /* Height of the scrollbar (for horizontal scrollbars) */\n//   }\n  \n//   /* Track */\n//   ::-webkit-scrollbar-track {\n// \tbackground: #504a4a; \n//   }\n  \n//   /* Handle */\n//   ::-webkit-scrollbar-thumb {\n// \tbackground: #888; \n// \tborder-radius: 6px;\n//   }\n  \n//   /* Handle on hover */\n//   ::-webkit-scrollbar-thumb:hover {\n// \tbackground: #555; \n//   }\n  \n//   /* Ensuring scrollbar is always visible */\n// .ordered-articles-container{\n// \toverflow-y: scroll; /* Ensures scrolling */\n// \t-webkit-overflow-scrolling: touch; /* Smooth scrolling for iOS */\n//   }\n  \n//   /* Style for container to ensure scrollbar is visible */\n// .ordered-articles-container::-webkit-scrollbar {\n// \tdisplay: block;\n//   }\n//   :host ::ng-deep .ordered-articles-container {\n// \toverflow-y: scroll; \n// \t-webkit-overflow-scrolling: touch; \n//   }\n  \n//   :host ::ng-deep ::-webkit-scrollbar {\n// \twidth: 12px; \n// \theight: 12px; \n//   }\n  \n//   :host ::ng-deep ::-webkit-scrollbar-track {\n// \tbackground: #f1f1f1; \n//   }\n  \n//   :host ::ng-deep ::-webkit-scrollbar-thumb {\n// \tbackground: #888; \n// \tborder-radius: 6px;\n//   }\n  \n//   :host ::ng-deep ::-webkit-scrollbar-thumb:hover {\n// \tbackground: #555; \n//   }\n\n::ng-deep .ordered-articles-container::-webkit-scrollbar {\n    -webkit-appearance: none;\n}\n\n::ng-deep .ordered-articles-containerl::-webkit-scrollbar:vertical {\n    width: 11px;\n     background-color:   rgb(233, 245, 233)\n}\n\n::ng-deep .ordered-articles-container::-webkit-scrollbar-thumb {\n    border-radius: 8px;\n    border: 2px solid rgb(233, 245, 233) !important; /* should match background, can't be transparent */\n    background-color: rgba(0, 0, 0, .5);\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
